<template>
  <div class="Contactos">
    <nav :class="{'active': menu}">
      <div class="nav-mobile">
        <router-link to="/portfolio">Portfolio</router-link>
        <router-link to="/atelier">Atelier </router-link> 
        <router-link to="/registos">Registos </router-link>
        <router-link class="current" to="/contactos">Contactos</router-link>
        <a class="cont">966 341 573</a>
        <div class="conts">
          geral@atelieradaoparanhos.com <br>
          rua calouste gulbenkian 52,<br>
          6º, E6 4050-144 porto
        </div>
      </div>
      <div class="nav-left">
        <router-link to="/portfolio">Portfolio </router-link>
        <span class="separador">&nbsp;</span>
        <router-link to="/atelier">Atelier </router-link>
        <span class="separador">&nbsp;</span>
        <router-link to="/registos">Registos </router-link>
        <span class="separador">&nbsp;</span>
        <span class="current">Contactos</span>
      </div>
    </nav>
    
    <div class="contactos-content">
      <div class="contactos-content-info">
        <h3><p><span>Atelier</span> Adão Paranhos</p> Rua Calouste Gulbenkian 52,6,E6 4050-144 porto, (+351) 222 081 847, <a href="mailto:geral@atelieradaoparanhos.com">geral@atelieradaoparanhos.com</a></h3>
        <div class="social">
          <a target="_blank" href="https://www.linkedin.com/in/paranhos-ad%C3%A3o-3a950431/">
            <img src="../assets/in.png">
          </a>
          <a target="_blank" href="https://www.behance.net/atelieradaoparanhos">
            <img src="../assets/be.png">
          </a>
          <a target="_blank" href="https://www.instagram.com/adaoparanhos/">
            <img src="../assets/ins.png">
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Contactos',
  data () {
    return {
      menu: true,
    }
  }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.contactos {
  &-content {
      background: black;
      width: 100%;
      height: calc(100vh - 100px);
      color: white;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 20px;
      text-transform: uppercase;
      
      &-info {
        width: 100%;
        max-width: 1920px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
            color: grey;
            text-transform: lowercase;
            font-size: 20px;
            display: inline-block;
            font-family: 'Ropa Sans', sans-serif;
            padding: 0;
            margin: 0;
            margin-right: 10px;
            span {
            color: #ff6200;
            }
        }
      }
      
      h3 {
        font-size: 13px;
        margin: 5px 0;
        text-transform: lowercase;
        a {
          color: #ff6200;
        }
      }
      .social {
        img {
          opacity: 0.7;
          height: 13px;
          margin-right: 10px;
          &:hover {
            opacity: 1;
          }
        }
        a:nth-child(2) {
          img {
            height: 21px;
          }
        }
      }
  }
}
@media (max-width: 768px) {
  .contactos-content-info {
    width: 200px;
  }
}

@media (min-width: 1920px) {
  .contactos-content h3 {
    font-size: 18px;
  }
  .contactos-content-info p {
    font-size: 24px;
  }
}

</style>
